export default __webpack_public_path__ + "locales/sr-Latn-RS/Files.json?hash=d3ad7479c722ae4497f308cead6c8ecb";